"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("invariant"));

var _formik = require("formik");

var _lodash = _interopRequireDefault(require("lodash.omit"));

var _FormikExtendedHandlers = _interopRequireDefault(require("./FormikExtendedHandlers"));

var _useFastestValidator = _interopRequireDefault(require("./useFastestValidator"));

var formikKnownProps = ['component', 'render', 'children', 'enableReinitialize', 'isInitialValid', 'initialStatus', 'initialValues', 'onReset', 'onSubmit', 'validate', 'validateOnBlur', 'validateOnChange', 'validationSchema'];
/**
 * Formik s extenzi.
 *
 * Reimplementuje spracovani chyb. Ktere jsou na vystupu v objektu.
 * Dale reimplementuje `handleChange`.
 */

function FormikExtended(props) {
  var children = props.children,
      onFormReleased = props.onFormReleased,
      onSave = props.onSave,
      pOnSubmit = props.onSubmit,
      _render = props.render,
      validate = props.validate,
      validationFastest = props.validationFastest,
      validationSchema = props.validationSchema,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "onFormReleased", "onSave", "onSubmit", "render", "validate", "validationFastest", "validationSchema"]);
  (0, _invariant.default)(children || _render, 'FormikExtended required at least one of `children` or `render` props to be defined.');
  (0, _invariant.default)(onSave || pOnSubmit, 'FormikExtended required at least one of `onSubmit` or `onSave` props to be defined.');
  var fastestValidator = (0, _useFastestValidator.default)();

  var onSubmit = _react.default.useMemo(function () {
    return pOnSubmit || function (values, _ref) {
      var setSubmitting = _ref.setSubmitting;
      return onSave(values).then(function (saved) {
        setSubmitting(false);
        return saved;
      }).then(function (saved) {
        return onFormReleased ? onFormReleased(saved) : saved;
      }).catch(function (err) {
        setSubmitting(false);
        throw err;
      });
    };
  }, [onFormReleased, onSave, pOnSubmit]);

  var validationFormikProps = _react.default.useMemo(function () {
    return validationFastest ? {
      validationSchema: undefined,
      validate: fastestValidator(validationSchema, typeof validationFastest === 'boolean' ? {} : validationFastest)
    } : {
      validate: validate,
      validationSchema: validationSchema
    };
  }, [fastestValidator, validate, validationFastest, validationSchema]);

  var fwd = (0, _lodash.default)((0, _extends2.default)({}, rest, {}, validationFormikProps), formikKnownProps);
  return _react.default.createElement(_formik.Formik, (0, _extends2.default)({}, rest, validationFormikProps, {
    onSubmit: onSubmit,
    render: function render(frmkProps) {
      return _react.default.createElement(_FormikExtendedHandlers.default, (0, _extends2.default)({}, frmkProps, fwd, {
        render: _render
      }), children);
    }
  }));
}

FormikExtended.propTypes = {
  /**
   * Render child funkce.
   */
  children: _propTypes.default.func,

  /**
   * Pokud je `true` reinicializuje se state formu po zmene `initialValues` prop.
   */
  enableReinitialize: _propTypes.default.bool,

  /**
   * Inicialni hodnoty formulare k  editaci.
   */
  initialValues: _propTypes.default.shape({}).isRequired,

  /** (props: Props) => Values */
  isInitialValid: _propTypes.default.bool,
  onFormReleased: _propTypes.default.func,
  onSave: _propTypes.default.func,

  /**
   * Custom submit handler.
   *
   * Pokud neni definovan. Bude pouzita standardni implementace:
   * ```js
   * const onSubmit = (values, { setSubmitting }) => {
   *   return onSave(values)
   *     .then((saved) => {
   *       setSubmitting(false);
   *       return saved;
   *     })
   *     .then((saved) => (
   *       (onFormReleased)
   *         ? onFormReleased(saved)
   *         : saved
   *     ))
   *     .catch((err) => {
   *       setSubmitting(false);
   *       throw err;
   *     });
   * }
   * ```
   */
  onSubmit: _propTypes.default.func,

  /**
   * Render prop.
   */
  render: _propTypes.default.func,

  /**
   * Handler pro validaci.
   * Signatura: `(values: Values) => FormikErrors | Promise`
   */
  validate: _propTypes.default.func,

  /**
   * Pokud je `true` bude se validovat po blur.
   */
  validateOnBlur: _propTypes.default.bool,

  /**
   * Pokud je `true` bude se validovat po change.
   */
  validateOnChange: _propTypes.default.bool,

  /**
   * Nastaveni pro `fastest-validator`. Pokud se ma pouzit fastest validator, musi byt tato prop
   * definovana.
   */
  validationFastest: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.bool]),

  /**
   * Definice validacny schemy. Podporovany jsou `yup` a `fastest-validator` validacny chemy.
   * `yup` schemy jsou standardni validacny schemy. Prop `yup` je podporovanyn vstupem jak objekt,
   * tak i funkce generujici validacni schema.
   *
   * `fastest-validator` je pouzit za predpokladu, ze ma prop `validationFastest` pravdivou hodnotu.
   * Jako hodnota prop `validationSchema` je podporovan pouze objekt.
   *
   * > Dynamicke generovani chcem doporucujeme provadet v v nadrazene komponente.
   *
   * Pokud je pouzita validacny chcema je ignorovana hodnota ve `validate` prop.
   */
  validationSchema: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.func])
};
FormikExtended.defaultProps = {
  children: undefined,
  enableReinitialize: false,
  isInitialValid: true,
  onFormReleased: undefined,
  onSave: undefined,
  onSubmit: undefined,
  render: undefined,
  validate: undefined,
  validateOnBlur: undefined,
  validateOnChange: undefined,
  validationFastest: undefined,
  validationSchema: undefined
};
var _default = FormikExtended;
exports.default = _default;